import { StdResponse, request } from "@/global/config/request";
import { User } from "@/global/interface/project-manage/user";

export function linkProjectUsers(projectId: number, userIds: number[], params?: {}): Promise<StdResponse<any>> {
    return request.post(`/projects/${projectId}/link-users`, userIds, {
        params: params,
    })
}

export function unlinkProjectUsers(projectId: number, userIds: number[], params?: {}): Promise<StdResponse<any>> {
    return request.post(`/projects/${projectId}/unlink-users`, userIds, {
        params: params,
    })
}

export function findProjectUsers(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectId}/users`, {
        params: params,
    })
}

export function findProjectUserAuths(projectId: number, userId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectId}/users/${userId}/user-auths`, {
        params: params,
    })
}

export function findProjectUserDetail(projectId: number, userId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectId}/users/${userId}/user-detail`, {
        params: params,
    })
}

export function updateProjectUserDetail(projectId: number, userId: number, user: User, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/projects/${projectId}/users/${userId}/update-user`, user, {
        params: params,
    })
}